import { useState } from 'react';
import { DevRequestDraft } from '@/features/project-board/dev-request-draft';
import { Modal } from '@/shared/ui/Modal';

export function RegisterDevRequestDialog(
  { draft, onSave, onClose }: { draft: { title: string; body: string }; onSave: (draft: { title: string; body: string }) => void; onClose: () => void }
): React.JSX.Element {
  const [title, setTitle] = useState(draft.title);
  const [body, setBody] = useState(draft.body);
  const error = DevRequestDraft.validation(title, body);
  return (
    <Modal
      open
      title="요청서 만들기"
      onClose={onClose}
    >
      <p className="my-3 text-xs text-muted">이미 진행된 작업을 묶은 요청서로 기록됩니다(접수: console). 슬랙·노션 알림은 나가지 않습니다. 비밀값이 섞이지 않았는지 확인한 뒤 저장하세요.</p>
      <form onSubmit={(event) => {
        event.preventDefault();
        if (error === null) onSave({ title, body });
      }} className="space-y-3">
        <label className="block text-xs">제목 (300자 이하)
          <input
            value={title}
            onChange={(event) => setTitle(event.target.value)}
            className="mt-1 block w-full rounded border border-line p-2"
          /></label>
        <label className="block text-xs">요청 내용 (200,000자 이하)
          <textarea
            rows={12}
            value={body}
            onChange={(event) => setBody(event.target.value)}
            className="mt-1 block w-full rounded border border-line p-2"
          /></label>
        {error !== null && <p role="alert" className="text-xs text-rose-700">{error}</p>}
        <button
          type="submit"
          disabled={error !== null}
          className="rounded border border-accent px-3 py-1 text-accent disabled:opacity-50"
        >저장</button>
      </form>
    </Modal>
  );
}
